import { Component, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';

function isGetter(message: string | ((seconds: number) => string)): message is (seconds: number) => string {
  // TS guard
  return typeof message === 'function';
}

@Component({
  standalone: false,
  selector: 'ti-mask-action',
  templateUrl: './mask-action.component.html',
  styleUrls: ['./mask-action.component.sass'],
})
export class MaskActionComponent implements OnDestroy {
  public readonly strings = tiStrings.app.misc;

  @Input() mainMessage: string | ((seconds: number) => string);
  @Input() optionalMessage: string | ((seconds: number) => string);
  @Input() secondsToAction: number = 0;
  @Input() finalCountdownDelta: number = 1;
  @Output() done = new EventEmitter();
  private interval: any;

  text: string = '';
  optionalText: string = '';

  private get isFinalCountdown() {
    return this.secondsToAction <= this.finalCountdownDelta;
  }

  constructor(private readonly cd: ChangeDetectorRef) {}

  start() {
    this.updateText();

    this.interval = setInterval(() => {
      this.secondsToAction--;

      this.updateText();

      this.cd.detectChanges();

      if (this.isFinalCountdown) {
        clearInterval(this.interval);
        setTimeout(() => {
          this.done.emit();
        }, this.finalCountdownDelta * 1000);
      }
    }, 1000);

    this.cd.detectChanges();
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  private updateText() {
    if (!this.isFinalCountdown) {
      this.text = this.getMessage(this.mainMessage);
      this.optionalText = this.getMessage(this.optionalMessage);
    } else {
      this.text = this.strings.signingOut;
      this.optionalText = '';
    }
  }

  private getMessage(message: string | ((seconds: number) => string)): string {
    return isGetter(message) ? message(this.secondsToAction) : message;
  }
}
